import animations from './animations'
import meshes from './meshes'
import textures from './textures'

export default {
    animations,
    meshes,
    textures,
}
